var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwdIc24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28571 8.58824C6.28571 7.10614 6.88775 5.68475 7.95939 4.63676C9.03103 3.58876 10.4845 3 12 3C13.5155 3 14.969 3.58876 16.0406 4.63676C17.1122 5.68475 17.7143 7.10614 17.7143 8.58824V11.0135C19.0457 11.474 20 12.7168 20 14.1765V18.6471C20 19.5363 19.6388 20.3891 18.9958 21.0179C18.3528 21.6467 17.4807 22 16.5714 22H7.42857C6.51926 22 5.64719 21.6467 5.00421 21.0179C4.36122 20.3891 4 19.5363 4 18.6471V14.1765C4 12.7168 4.95429 11.474 6.28571 11.0135V8.58824ZM8.57143 10.8235H15.4286V8.58824C15.4286 7.69898 15.0673 6.84615 14.4244 6.21735C13.7814 5.58855 12.9093 5.23529 12 5.23529C11.0907 5.23529 10.2186 5.58855 9.57563 6.21735C8.93265 6.84615 8.57143 7.69898 8.57143 8.58824V10.8235ZM7.42857 13.0588C7.12547 13.0588 6.83478 13.1766 6.62045 13.3862C6.40612 13.5958 6.28571 13.8801 6.28571 14.1765V18.6471C6.28571 18.9435 6.40612 19.2278 6.62045 19.4374C6.83478 19.647 7.12547 19.7647 7.42857 19.7647H16.5714C16.8745 19.7647 17.1652 19.647 17.3796 19.4374C17.5939 19.2278 17.7143 18.9435 17.7143 18.6471V14.1765C17.7143 13.8801 17.5939 13.5958 17.3796 13.3862C17.1652 13.1766 16.8745 13.0588 16.5714 13.0588H7.42857Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdIc24X24);
export default __webpack_public_path__ + "static/media/pwd_ic_24x24.919bce15adfb528310a0dd68485268ed.svg";
export { ForwardRef as ReactComponent };